module.exports = __webpack_public_path__ + "img/tab-5.eaa494e3.svg";